import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges } from '@angular/core';
import {StoreAttributeTypeViewModel, canEditAttributeValues, canEnableAsFilter, DisplayColor} from '../../../models/store-attribute.model';

export interface ManageValuesEvent {
  attributeType: StoreAttributeTypeViewModel;
  categoryName: string;
}

export interface FilterEnabledChangeEvent {
  attributeType: StoreAttributeTypeViewModel;
  enabled: boolean;
}

@Component({
  selector: 'app-store-attribute-type-row',
  templateUrl: './attribute-type-row.component.html',
  styleUrls: ['./attribute-type-row.component.scss'],
})
export class StoreAttributeTypeRowComponent implements OnChanges {
  @Input() attributeType!: StoreAttributeTypeViewModel;
  @Input() categoryName!: string;
  @Input() categoryColor!: DisplayColor;
  @Input() filterToggleSaving = false;
  @Output() manageValues = new EventEmitter<ManageValuesEvent>();
  @Output() deleteType = new EventEmitter<StoreAttributeTypeViewModel>();
  @Output() filterEnabledChange = new EventEmitter<FilterEnabledChangeEvent>();

  readonly maxVisibleValues = 15;
  localFilterEnabled = false;

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['attributeType']) {
      this.localFilterEnabled = this.attributeType.filterEnabled;
    }
  }

  get visibleValues() {
    return this.attributeType.values.slice(0, this.maxVisibleValues);
  }

  get hiddenValueCount(): number {
    return Math.max(0, this.attributeType.values.length - this.maxVisibleValues);
  }

  get canEditValues(): boolean {
    return canEditAttributeValues(
      this.attributeType.valueType,
      this.attributeType.sourceField,
    );
  }

  get canEnableFilter(): boolean {
    return canEnableAsFilter(this.attributeType.valueType);
  }

  get tagClass(): string {
    const map: Record<DisplayColor, string> = {
      blue: 'sat-tag--geo',
      red: 'sat-tag--alc',
      green: 'sat-tag--health',
      orange: 'sat-tag--fresh',
      purple: 'sat-tag--svc',
      teal: 'sat-tag--org',
      brown: 'sat-tag--neutral',
      grey: 'sat-tag--neutral',
    };

    return map[this.categoryColor] ?? 'sat-tag--neutral';
  }

  onEditValues(): void {
    this.manageValues.emit({
      attributeType: this.attributeType,
      categoryName: this.categoryName,
    });
  }

  onDeleteType(): void {
    this.deleteType.emit(this.attributeType);
  }

  onFilterToggle(enabled: boolean): void {
    if (this.filterToggleSaving || !this.canEnableFilter || enabled === this.localFilterEnabled) {
      return;
    }
    this.localFilterEnabled = enabled;
    this.filterEnabledChange.emit({
      attributeType: this.attributeType,
      enabled,
    });
  }
}
